<template>
  <BaseBlock
    v-if="block.type"
    :block="block"
    @close-click="$emit('close-click')"
    :showTitle="showTitle"
  >
    <BlockInner :block="block"></BlockInner>
  </BaseBlock>
</template>

<script>
import BaseBlock from "./BaseBlock";
import BlockInner from "./BlockInner";

export default {
  props: ["block", "showTitle"],
  components: {
    BaseBlock,
    BlockInner,
  },
};
</script>
